import React, { useState, useEffect, useContext } from "react";
import DatePicker from "react-datepicker";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import { format, addMinutes, setHours, setMinutes, startOfDay } from "date-fns";

import { UserContext } from "../../context/UserContext";
import { getCartByUserId } from "../../services/Cart/CartPage";
import { SlotContext } from "../../context/SlotContext";

export default function Slots() {
  const { user } = useContext(UserContext);
  const { selectedSlot, setSelectedSlot } = useContext(SlotContext);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [slots, setSlots] = useState([]);
  const [storeId, setStoreId] = useState(null);

  // ✅ API Base URL from env
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  /* ================= GET STORE ID ================= */
  useEffect(() => {
    const fetchCart = async () => {
      if (!user?.userId) return;

      try {
        const cart = await getCartByUserId(user.userId);

        if (cart?.items?.length > 0) {
          setStoreId(cart.items[0].storeId);
        }
      } catch (err) {
        console.error("Cart API error:", err);
      }
    };

    fetchCart();
  }, [user]);

  /* ================= FETCH SHIFT ================= */
  useEffect(() => {
    const fetchShift = async () => {
      if (!storeId) return;

      try {
        // ✅ Using env URL
        const resp = await axios.get(
          `${API_BASE_URL}CompanyAPI/GetShiftByStore?storeId=${storeId}`
        );

        generateSlots(resp.data);
      } catch (err) {
        console.error("Shift API error:", err);
      }
    };

    fetchShift();
  }, [storeId, selectedDate, API_BASE_URL]);

  /* ================= GENERATE SLOTS ================= */
  const generateSlots = (shiftData) => {
    const jsDay = selectedDate.getDay();
    const dayOfWeek = jsDay === 0 ? 7 : jsDay;

    const todayShift = shiftData.find(
      (shift) => shift.dayOfWeek === dayOfWeek
    );

    if (!todayShift || !todayShift.openTime || !todayShift.closeTime) {
      setSlots([]);
      return;
    }

    const [openH, openM] = todayShift.openTime.split(":").map(Number);
    const [closeH, closeM] = todayShift.closeTime.split(":").map(Number);

    let start = setHours(setMinutes(startOfDay(selectedDate), openM), openH);
    let end = setHours(setMinutes(startOfDay(selectedDate), closeM), closeH);

    const now = new Date();
    const slotList = [];

    while (start < end) {
      if (
        format(selectedDate, "yyyy-MM-dd") === format(now, "yyyy-MM-dd") &&
        start < now
      ) {
        start = addMinutes(start, 60);
        continue;
      }

      slotList.push(format(start, "hh:mm a"));
      start = addMinutes(start, 60);
    }

    setSlots(slotList);
  };

  return (
    <div className="p-3 border rounded-3 mt-2 shadow-sm bg-white">

      {/* TITLE */}
      <h5 className="mb-2 fw-bold text-dark">Select Slot</h5>

      {/* DATE PICKER (14 DAYS LIMIT) */}
      <div className="mb-3">
        <label className="form-label text-muted small mb-1">
          Select Date
        </label>

        <DatePicker
          selected={selectedDate}
          onChange={(date) => setSelectedDate(date)}
          minDate={new Date()}
          maxDate={addMinutes(new Date(), 14 * 24 * 60)}
          dateFormat="dd MMM yyyy"
          className="form-control py-2 px-3 rounded-3 border-0 shadow-sm"
          placeholderText="Select Date"
        />
      </div>

      {/* SLOTS */}
      <div className="d-flex flex-wrap gap-2">
        {slots.length === 0 ? (
          <span className="text-danger fw-semibold">
            No slots available
          </span>
        ) : (
          slots.map((slot, index) => (
            <button
              key={index}
              className={`btn btn-sm rounded-pill px-3 py-1 ${
                selectedSlot?.time === slot
                  ? "btn-danger"
                  : "btn-outline-danger"
              }`}
              style={{ minWidth: "85px" }}
              onClick={() =>
                setSelectedSlot({
                  date: selectedDate,
                  time: slot
                })
              }
            >
              {slot}
            </button>
          ))
        )}
      </div>

    </div>
  );
}